import { CircleCheckBig } from 'lucide-react';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';

export const SandboxBanner = () => {
  const { sandboxBannerMessage } = useLaunchDarkly();

  const message = sandboxBannerMessage?.trim() || '';

  if (!message) {
    return null;
  }

  return (
    <div className='flex items-center justify-center gap-2.5 bg-green-100 dark:bg-green-950/40 px-4 py-2 border-b border-green-300 dark:border-green-800'>
      <CircleCheckBig className='size-4 shrink-0 text-green-700 dark:text-green-500' />
      <span className='font-semibold text-sm text-green-900 dark:text-green-300'>
        {message}
      </span>
    </div>
  );
};
